const API_BASE_URL = "/api/v1"

const reasonsForSignup = [
  "Podcaster",
  "Radio host",
  "Streamer",
  "Teacher",
  "Church",
  "Musician",
  "Theater",
  "Gamer",
  "Sports",
  "Events",
  "Other",
]

export { API_BASE_URL, reasonsForSignup }
